<template>
  <a
    v-if="section"
    :class="[hover ? 'bg-highlight-100' : 'text-secondary']"
    class="text-secondary group cursor-pointer font-semibold items-baseline w-full block py-1 px-2 rounded-md"
    @mouseenter="() => (hover = true)"
    @mouseleave="() => (hover = false)"
    @click="() => scrollToSection(section.code)"
  >
    <div class="flex justify-between mx-2 min-h-[2rem] items-center" :class="isEnabled ? 'text-secondary' : 'text-slate-500'">
      <div
        :class="`col-span-2 grow toc-paragraph-item ${paragraphNum ? 'toc-paragraph-counter' : ''} `"
        :data-toc-paragraph-counter="paragraphNum ?? 0"
      >
        <EyeSlashIcon v-if="!isEnabled" class="w-4 h-4 inline-block" />
        {{ section.name }}
      </div>
      <div v-show="hover" class="flex space-x-2 self-end justify-end">
        <EditClauseButton :section="section" size="small" />
        <RemoveClauseButton v-if="isEnabled" :section="section" size="small" />
        <AddClauseButton v-if="!isEnabled" :optional="section.optional" :code="section.code" :text="section.name!" />
      </div>
    </div>
  </a>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import EditClauseButton from './EditClauseButton.vue'
import { useLegalDocumentTemplateStore } from '@/questionnaire/stores/legalDocumentTemplate'
import { useLegalDocumentStore } from '@/questionnaire/stores/legalDocument'
import RemoveClauseButton from './RemoveClauseButton.vue'
import { EyeSlashIcon } from '@heroicons/vue/24/outline'
import AddClauseButton from './AddClause.vue'

const props = defineProps<{ item: string; paragraphNum: number | undefined }>()
const legalDocumentTemplateStore = useLegalDocumentTemplateStore()
const legalDocumentStore = useLegalDocumentStore()
const section = computed(() => legalDocumentTemplateStore.sections[props.item])
const isEnabled = computed(() => legalDocumentStore.sections.includes(props.item))

const hover = ref(false)

const scrollToSection = (code: string) => {
  const section = document.getElementById(`clause-${code}`)
  if (section) {
    section.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>
